import { create } from "zustand";

/** The document the opener has most recently asked the viewer to show. */
export interface FocusedDocument {
  appId: string;
  docId: string;
  fileName: string;
  contentType: string;
  reviewedBy?: string | null;
}

interface DocumentViewerState {
  focusedDocument?: FocusedDocument;
  setFocusedDocument: (document_: FocusedDocument) => void;
  clearFocusedDocument: () => void;
}

/**
 * Opener-side store for the currently-focused document (OR-22558). The Docs &
 * Msgs panel writes here on a document click; `useDocumentBroadcaster` reads it and
 * broadcasts the selection to the viewer window. Lives only in the opener
 * window — the viewer has its own state driven by the BroadcastChannel.
 */
export const useDocumentViewerStore = create<DocumentViewerState>((set) => ({
  focusedDocument: undefined,
  setFocusedDocument: (focusedDocument) => set({ focusedDocument }),
  clearFocusedDocument: () => set({ focusedDocument: undefined }),
}));
